module.exports = __webpack_public_path__ + "img/cropper-img-temp.e9e2b0ed.jpg";